import styled, { keyframes } from "styled-components";

import Colors from "@constants/Colors";

export const CustomBarWrapper = styled.div<{
  errorState: boolean;
}>`
  height: 18px;
  background: ${(props) =>
    props?.errorState ? Colors.secondaryred_50 : Colors.neutralwhite};
  box-shadow: ${Colors.Elevation_2};
`;

export const BarWrapper = styled.div``;

const load = keyframes`
0% { width: 0; }
100% { width: 100%; }
`;

export const FillerBackground = styled.div<{
  width: number;
}>`
  height: inherit;
  transition: "width 2s ease-i-out";
  background: linear-gradient(
    90.04deg,
    ${Colors.secondarypurple} 0.04%,
    ${Colors.secondarypurple_35} 22.95%,
    ${Colors.secondarypurple_66} 73.43%,
    ${Colors.secondarypurple_97} 99.98%
  );
  width: ${(props) => props.width}%;
  animation: ${load} 3s normal forwards;
  animation-timing-function: ease;
`;

export const Filler = styled.div<{ width: number }>`
  transition: "width 2s ease-i-out";
  height: inherit;
  border-radius: 0px;
  overflow: hidden;
  width: ${(props) => props.width}%;
`;

export const BarContainer = styled.div<{
  emptyState: boolean;
}>`
  flex: 1;
  height: 18px;
  background: ${(props) =>
    props.emptyState ? Colors.secondaryred_50 : Colors.neutralwhite};
  border-radius: 4px;
  overflow: hidden;
`;
